<template>
    <section :class="['careers', $route.name]" id="careers">
        <router-view></router-view>
    </section>
</template>

<script>
  export default {
    name: 'Careers',
    data() {
      return {
      }
    },
  }
</script>